<div>
	<p-table #dt class="snmpif-devices-table" [value]="entries" dataKey="settingsEntryGuid"
			 [resizableColumns]="true"
			 [scrollable]="true" scrollHeight="calc(400px)"
			 [customSort]="true" (sortFunction)="doCustomSort($event)">

		<ng-template pTemplate="header">
			<tr>
				<th pResizableColumn pSortableColumn="deviceName">
					Device
					<p-sortIcon field="deviceName"></p-sortIcon>
				</th>
				<th pResizableColumn pSortableColumn="deviceDescription">
					Device Description
					<p-sortIcon field="deviceDescription"></p-sortIcon>
				</th>
				<th pResizableColumn pSortableColumn="ipAddress">
					IP Address
					<p-sortIcon field="ipAddress"></p-sortIcon>
				</th>
				<th pResizableColumn pSortableColumn="ifIndex">
					IF Index
					<p-sortIcon field="ifIndex"></p-sortIcon>
				</th>
				<th pResizableColumn pSortableColumn="ifName">
					IF Name
					<p-sortIcon field="ifName"></p-sortIcon>
				</th>
				<th pResizableColumn pSortableColumn="inOutMbps">
					In/Out MBPS
					<p-sortIcon field="inOutMbps"></p-sortIcon>
				</th>
				<th pResizableColumn pSortableColumn="stateDetails">
					State Details
					<p-sortIcon field="stateDetails"></p-sortIcon>
				</th>
				<th pResizableColumn pSortableColumn="state">
					State
					<p-sortIcon field="state"></p-sortIcon>
				</th>
				<th class="uv-table-button-column-2">
					<!-- Action Buttons -->
				</th>
			</tr>

			<tr class="uv-table-filter">
				<th>
					<input pInputText type="text" style="width: 100%;"
						(input)="dt.filter($event.target.value, 'deviceName', 'contains')">
				</th>
				<th>
					<input pInputText type="text" style="width: 100%;"
						(input)="dt.filter($event.target.value, 'deviceDescription', 'contains')">
				</th>
				<th>
					<input pInputText type="text" style="width: 100%;"
						(input)="dt.filter($event.target.value, 'ipAddress', 'contains')">
				</th>
				<th>
					<input pInputText type="text" style="width: 100%;"
						(input)="dt.filter($event.target.value, 'ifIndex', 'contains')">
				</th>
				<th>
					<input pInputText type="text" style="width: 100%;"
						(input)="dt.filter($event.target.value, 'ifName', 'contains')">
				</th>
				<th>
					<input pInputText type="text" style="width: 100%;"
						(input)="dt.filter($event.target.value, 'inOutMbps', 'contains')">
				</th>
				<th>
					<input pInputText type="text" style="width: 100%;"
						(input)="dt.filter($event.target.value, 'stateDetails', 'contains')">
				</th>
				<th>
					<input pInputText type="text" style="width: 100%;"
						(input)="dt.filter($event.target.value, 'state', 'contains')">
				</th>
				<th class="uv-table-button-column-2">
					<!-- Action Buttons -->
				</th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
			<tr [pSelectableRow]="rowData">
				<td>
					<span class="uv-table-value">{{rowData['deviceName']}}</span>
				</td>
				<td>
					<span class="uv-table-value">{{rowData['deviceDescription']}}</span>
				</td>
				<td>
					<span class="uv-table-value">{{rowData['ipAddress']}}</span>
				</td>
				<td>
					<span class="uv-table-value">{{rowData['ifIndex']}}</span>
				</td>
				<td>
					<span class="uv-table-value">{{rowData['ifName']}}</span>
				</td>
				<td>
					<span class="uv-table-value">{{rowData['inOutMbps']}}</span>
				</td>
				<td pTooltip="{{rowData['stateDetails']}}">
					<span class="uv-table-value">{{rowData['stateDetails']}}</span>
				</td>
				<td [className]="rowData['style']">
					<span class="uv-table-value">{{rowData['state']}}</span>
				</td>
				<td class="uv-table-button-column-2">
					<button type="button" class="btn btn-primary uv-first-table-button" (click)="editDevice(rowData)"
							title="Modify which of this device's interfaces are being monitored">
						<i class="fa fa-edit"></i>
					</button>
					
					<button type="button" class="btn btn-danger uv-table-button" (click)="deleteDevice(rowData)" 
							title="Remove all of this device's interfaces from the monitor">
						<i class="pi pi-trash"></i>
					</button>
				</td>
			</tr>
		</ng-template>

	</p-table>

	<form [formGroup]="SettingsForm">
		<div style="margin-top: 20px; margin-bottom: 20px;">
			<input type="checkbox" style="margin-left: 10px;" [formControl]="UseHostnames" />
			<span class="uv-checkbox-label">Use Hostnames</span>
		</div>
	</form>

	<div style="margin-top: 3px;">
		<button type="button" (click)="addDevice()" pButton icon="fa fa-plus-square-o" label="Add Device"></button>
		<button type="button" (click)="refreshEntries()" pButton icon="fa fa-refresh" label="Refresh"></button>
	</div>

	<monitor-device-selector header="Select Devices to Monitor" [(visible)]="deviceSelectorVisible"
							 defaultFilter="<SNMP Devices>" [requireSnmp]="true"
							 (onOk)="onDeviceSelectorOk($event)" (onCancel)="onDeviceSelectorCancel()">
	</monitor-device-selector>

	<snmpif-selector [(visible)]="interfaceSelectorVisible" [device]="targetDevice"
					 [initialSelection]="initialInterfaceSelection"
					 (onOk)="onInterfaceSelectorOk($event)" (onCancel)="onInterfaceSelectorCancel()">
	</snmpif-selector>

</div>